function init() {
  function isAllowedOrigin(origin, allowlist) {
    if (!allowlist || allowlist === '*') {
      return true;
    }

    if (!origin) {
      return false;
    }

    if (Array.isArray(allowlist)) {
      return allowlist.indexOf(origin) > -1;
    }

    return allowlist === origin;
  }

  function safeParseMessage(event) {
    if (!event || typeof event.data !== 'string') {
      return null;
    }

    var allowlist = window.__abAllowedOrigins || '*';
    if (!isAllowedOrigin(event.origin, allowlist)) {
      return null;
    }

    try {
      var data = JSON.parse(event.data);
      if (!data || typeof data.action !== 'string') {
        return null;
      }
      return data;
    } catch (e) {
      console.log('Module injector cannot parse message : ', event.data);
      console.log('Error occured: ', e);
      return null;
    }
  }

  function receiveMessage(event) {
    var data = safeParseMessage(event);
    if (!data) {
      return;
    }

    if (data.action === 'evalCode') eval(data.data);
  }
  window.addEventListener('message', receiveMessage, false);
}

export default init;
